var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3773_135330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.422 150 75.0002C150 33.5788 116.421 0.000152588 75 0.000152588C33.5786 0.000152588 0 33.5788 0 75.0002C0 116.422 33.5786 150 75 150Z",
    fill: "#D1E4FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 41,
    width: 187.428,
    height: 56.2283,
    rx: 12.4952,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2321 69.1142C87.2321 59.1079 79.1204 50.9961 69.1141 50.9961C59.1078 50.9961 50.9961 59.1079 50.9961 69.1142C50.9961 79.1205 59.1078 87.2322 69.1141 87.2322C79.1204 87.2322 87.2321 79.1205 87.2321 69.1142Z",
    fill: "#013B8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9879 74.9794C69.539 74.9792 71.0454 74.4602 72.2675 73.505L76.1098 77.3473L77.3456 76.1115L73.502 72.268C74.4677 71.0195 74.982 69.4807 74.9612 67.9025C74.9404 66.3242 74.3856 64.7996 73.3874 63.577C72.3891 62.3544 71.0062 61.506 69.464 61.17C67.9218 60.8339 66.3112 61.0302 64.8948 61.7266C63.4784 62.4231 62.3397 63.5788 61.6642 65.0053C60.9887 66.4318 60.8163 68.0451 61.175 69.5822C61.5337 71.1192 62.4025 72.4895 63.6397 73.4696C64.8769 74.4497 66.4095 74.9819 67.9879 74.9794ZM67.9879 62.7417C69.0259 62.7417 70.0405 63.0495 70.9035 63.6261C71.7666 64.2028 72.4392 65.0224 72.8364 65.9813C73.2336 66.9403 73.3376 67.9955 73.1351 69.0135C72.9326 70.0315 72.4327 70.9666 71.6988 71.7005C70.9649 72.4345 70.0298 72.9343 69.0117 73.1368C67.9937 73.3393 66.9385 73.2353 65.9796 72.8381C65.0207 72.4409 64.201 71.7683 63.6244 70.9053C63.0477 70.0422 62.7399 69.0276 62.7399 67.9896C62.7399 66.5978 63.2929 65.2629 64.277 64.2788C65.2612 63.2946 66.5961 62.7417 67.9879 62.7417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2266,
    y: 59.118,
    width: 81.2613,
    height: 7.49711,
    rx: 3.74855,
    fill: "#F0F6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2266,
    y: 71.6132,
    width: 101.056,
    height: 7.49711,
    rx: 3.74855,
    fill: "#F0F6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 102.226,
    width: 187.428,
    height: 56.2283,
    rx: 12.4952,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2321 130.341C87.2321 120.334 79.1204 112.223 69.1141 112.223C59.1078 112.223 50.9961 120.334 50.9961 130.341C50.9961 140.347 59.1078 148.459 69.1141 148.459C79.1204 148.459 87.2321 140.347 87.2321 130.341Z",
    fill: "#013B8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9879 136.206C69.539 136.206 71.0454 135.687 72.2675 134.731L76.1098 138.574L77.3456 137.338L73.502 133.494C74.4677 132.246 74.982 130.707 74.9612 129.129C74.9404 127.551 74.3856 126.026 73.3874 124.803C72.3891 123.581 71.0062 122.732 69.464 122.396C67.9218 122.06 66.3112 122.257 64.8948 122.953C63.4784 123.65 62.3397 124.805 61.6642 126.232C60.9887 127.658 60.8163 129.272 61.175 130.809C61.5337 132.346 62.4025 133.716 63.6397 134.696C64.8769 135.676 66.4095 136.208 67.9879 136.206ZM67.9879 123.968C69.0259 123.968 70.0405 124.276 70.9035 124.853C71.7666 125.429 72.4392 126.249 72.8364 127.208C73.2336 128.167 73.3376 129.222 73.1351 130.24C72.9326 131.258 72.4327 132.193 71.6988 132.927C70.9649 133.661 70.0298 134.161 69.0117 134.363C67.9937 134.566 66.9385 134.462 65.9796 134.065C65.0207 133.667 64.201 132.995 63.6244 132.132C63.0477 131.269 62.7399 130.254 62.7399 129.216C62.7399 127.824 63.2929 126.489 64.277 125.505C65.2612 124.521 66.5961 123.968 67.9879 123.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2266,
    y: 120.344,
    width: 81.2613,
    height: 7.49711,
    rx: 3.74855,
    fill: "#F0F6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2266,
    y: 132.84,
    width: 101.056,
    height: 7.49711,
    rx: 3.74855,
    fill: "#F0F6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3773_135330"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.000152588,
    width: 150,
    height: 150,
    rx: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSettingsIcon);
export default __webpack_public_path__ + "static/media/filterSettingsIcon.30372462b1cfde76e49b69cf28c1772d.svg";
export { ForwardRef as ReactComponent };